module.exports = __webpack_public_path__ + "static/media/instagram.5a3fb083.svg";